import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

export const raceEligible = (user) => !!user && (user.roles || []).includes("RM") && !!user.hl_rm_value && !(user.roles || []).some((r) => r === "Admin" || r === "Viewer (QA)") && !user.viewer && !/test|qa/i.test((user.email || "").split("@")[0]);

/** T2: one-time, un-skippable "You're in the race" card for HL RMs. No close, no Esc — only the two buttons record participation. */
export function RaceGate({ children }) {
  const { user, checkAuth: refresh } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  if (!raceEligible(user) || user?.race?.participating || done) return children;
  const join = async (button) => {
    setBusy(true);
    try {
      const { data } = await api.post("/leaderboard/join", { button });
      toast.success(<span data-testid="race-welcome">🎉🎊✨ Welcome to the race, {data.first_name}. May your CIBIL be high 🙏</span>, { duration: 1000 });
      setDone(true);
      if (refresh) await refresh();
      navigate("/leaderboard");
    } catch { toast.error("Couldn't record that — try again"); setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[200] bg-[#1B1B1B] text-white flex items-center justify-center p-6" data-testid="race-gate" onKeyDown={(e) => e.stopPropagation()}>
      <div className="max-w-xl w-full space-y-6 animate-in fade-in zoom-in-95 duration-300">
        <div className="text-5xl">🏁</div>
        <h1 className="text-2xl sm:text-3xl font-bold">The RM Desk Weekly has begun.</h1>
        <p className="text-base text-white/80 leading-relaxed">Every Monday at 10 am, one of you is crowned Loan Ranger 👑. Points come from working in RM Desk. Direct Airtable edits cost −5.</p>
        <p className="text-base text-white/80">Participation is mandatory, like EMIs. Choose wisely:</p>
        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <button disabled={busy} onClick={() => join("im_in")} data-testid="race-btn-in" className="flex-1 rounded-full bg-[#FF4802] hover:bg-[#E2521B] px-5 py-3 font-semibold transition-colors">I'm in. Bring it on 😎</button>
          <button disabled={busy} onClick={() => join("no_choice")} data-testid="race-btn-no-choice" className="flex-1 rounded-full border border-white/40 hover:bg-white/10 px-5 py-3 font-medium transition-colors">Do I have a choice? 🙃 <span className="block text-xs text-white/60">(No. You're in.)</span></button>
        </div>
      </div>
    </div>
  );
}
